/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { from, mergeMap } from 'rxjs';
import { inject } from '@angular/core';
import { IncludeBearerTokenCondition } from 'keycloak-angular';
import { EnvironmentService } from '../core/services/environment.service';
import { KeycloakService } from '../core/services/keycloak-service';
import Keycloak from 'keycloak-js';
import { ClusterUrlProviderService } from '../core/services/cluster-url-provider.service';

const BEARER_PREFIX = 'Bearer';
const AUTHORIZATION_HEADER_NAME = 'Authorization';

export const keycloakBearerInterceptor = (req, next) => {
    const includeUrls = inject(EnvironmentService).serviceUrls
        .concat(Object.values(inject(ClusterUrlProviderService).clusterMap))
        .map((url) => ({ urlPattern: new RegExp(url, 'i') } as IncludeBearerTokenCondition));
    const matchingCondition = includeUrls.find((condition) => findMatchingCondition(req, condition));
    if (!matchingCondition) {
        return next(req);
    }
    const keycloak = inject(KeycloakService).keycloak;
    return from(updateToken(keycloak))
        .pipe(mergeMap(() => keycloak?.authenticated ? addAuthorizationHeader(req, next, keycloak, matchingCondition) : next(req)));
};

const findMatchingCondition = ({ method, url }, { urlPattern, httpMethods = [] }) => {
    const httpMethodTest = httpMethods.length === 0 || httpMethods.join().indexOf(method.toUpperCase()) > -1;
    const urlTest = urlPattern.test(url);
    return httpMethodTest && urlTest;
};

const updateToken = async (keycloak?: Keycloak) => await keycloak?.updateToken().catch(() => false);

const addAuthorizationHeader = (req, next, keycloak, condition) => {
    const { bearerPrefix = BEARER_PREFIX, authorizationHeaderName = AUTHORIZATION_HEADER_NAME } = condition;
    const clonedRequest = req.clone({
        setHeaders: {
            [authorizationHeaderName]: `${bearerPrefix} ${keycloak.token}`
        }
    });
    return next(clonedRequest);
};
